module.exports = __webpack_public_path__ + "static/media/layer5.c866f42b.png";